export default __webpack_public_path__ + "static/media/Firebase.65c4fe9f.png";